import React,{useState,useEffect} from "react";
import { Container,Card,Table} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Header from "./Header";
import DateRange from "../../../components/formfields/DateRange";
import Product from "../../../components/formfields/Product";
import dateFormat from "dateformat";
import API from "../../../utils/API";
import SummaryChart from "./SummaryChart";
import Dateday from "../../../components/fields/Dateday";
import MoneyTotal from "../../../components/fields/MoneyTotal";

const Ecommerce = () => {

    const defaultDate = dateFormat((new Date()).setDate((new Date()).getDate() - 6),"mmm d, yyyy")+" to "+dateFormat(new Date(),"mmm d, yyyy")

    const [filtration,setFiltration] = useState({date:defaultDate, product: []})
    const [loading, setLoading] = useState(true)
    const [data,setData] = useState(null)

    let totalLeads = 0, totalTotal = 0

    const changeData = (name,value) => {
        setFiltration({ ...filtration, [name]: value })
    }

    useEffect(() => {
        if (filtration.date) {
            setLoading(true)
            API.post('/publisher/dashboard', filtration).then((response) => {
                setData(response.data.data)
                setLoading(false)
            })
        }
    }, [filtration])

    return(
    <Container fluid className="p-0">
        <Header/>
        <div style={{width:"300px"}}>
            <DateRange
                onChange={changeData}
                name={'date'}
                value={defaultDate}
            />
        </div>
        {data &&
            <Card className="flex-fill w-100 mt-3">
                <div>
                <AvForm className="d-inline-block" style={{ marginLeft: 10, paddingTop: 10 }}>
                    <Product
                        name="product"
                        value={filtration.product && filtration.product[0] ? filtration.product[0] : ""}
                        onChange={(e) => changeData("product", e.target.value ? [e.target.value] : [])}
                    />
                </AvForm>
                </div>
            <div className="row mt-1">
                {data.length > 2 &&
                    <div className="col-md-8 col-sm-12">
                        <SummaryChart inputData={data}/>
                    </div>
                }
                <div className="col-md-4 col-sm-12" style={{overflowY:"auto",maxHeight:"430px"}}>
                        <div className="table-responsive">
                            <Table striped borderless className="my-0">
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Matched</th>
                                    <th>Revenue</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data.map((dataItem,dataIndex)=>{
                                        totalLeads += dataItem.leads
                                        totalTotal += dataItem.total
                                        return (
                                            <tr key={dataIndex}>
                                                <td><Dateday dateDay={dataItem.date}/></td>
                                                <td className="font-weight-bold">{dataItem.leads}</td>
                                                <td>{dataItem.total?<MoneyTotal money={(dataItem.total)}/>:'$0'}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td/>
                                    <td className="font-weight-bold">{totalLeads}</td>
                                    <td className={`font-weight-bold`}>{totalTotal?<MoneyTotal money={totalTotal}/>:'$0'}</td>
                                </tr>
                                </tbody>
                            </Table>
                        </div>
                </div>
            </div>
            </Card>
        }
    </Container>
    )
};

export default Ecommerce;
